




























































































// Vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// models
import { ConcubineModel } from '@/models/config'

// components
import { Input, Select, DatePicker } from '@/components/form'

// constants
import { documentTypes } from '@/constants'

@Component({
    name: 'TableConcubine',
    components: {
        Input,
        Select,
        DatePicker
    }
})
export default class TableConcubine extends Vue {
    @Prop({ required: true }) concubine!: ConcubineModel
    @Prop({ type: Object, default: {} }) validations!: {}

    documentTypes = documentTypes
}
